var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegram = function SvgTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 5.75,
    stroke: "currentColor",
    strokeWidth: 2.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.258 7.04525C20.258 7.04525 21.8769 6.414 21.742 7.94704C21.697 8.5783 21.2923 10.7877 20.9775 13.1774L19.8983 20.2565C19.8983 20.2565 19.8084 21.2935 18.9989 21.4739C18.1895 21.6542 16.9753 20.8426 16.7505 20.6623C16.5706 20.527 13.3778 18.498 12.2536 17.506C11.9388 17.2355 11.579 16.6944 12.2985 16.0631L17.0203 11.5542C17.5599 11.0131 18.0995 9.75063 15.8511 11.2837L9.55546 15.5672C9.55546 15.5672 8.83596 16.018 7.48692 15.6123L4.56393 14.7105C4.56393 14.7105 3.48467 14.0341 5.3284 13.3578C9.82529 11.2385 15.3565 9.07425 20.258 7.04525Z",
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export default ForwardRef;